import clsx from 'clsx';
import React, { useRef, useState } from 'react';

import searchIcon from 'images/search_icon_white.svg';

import { search_page_path } from '../../../routes';
import styles from './styles.module.scss';

export default function SearchBar({
  inDarkMode = false,
  isSearchLandingPage,
  placeholder,
  scope,
}: {
  inDarkMode?: boolean;
  isSearchLandingPage: boolean;
  placeholder: string;
  scope: string;
}) {
  const [query, setQuery] = useState('');
  const inputRef = useRef<HTMLInputElement>();

  const handleChange = (e) => setQuery(e.target.value);

  return (
    <div
      className={clsx(
        {
          [styles.smallSearchBar]: isSearchLandingPage,
        },
        styles.searchBar
      )}
    >
      <form
        id="form_id"
        action={search_page_path()}
        method="get"
        className={styles.searchForm}
        data-id="search-form"
      >
        <div className={styles.searchInputContainer}>
          <input
            type="text"
            name="query"
            className={clsx(styles.searchInput, {
              [styles.darkModeInput]: inDarkMode,
            })}
            placeholder={placeholder}
            value={query}
            onChange={handleChange}
            ref={inputRef}
          />
          <button type="submit" className={styles.searchInputIcon}>
            <img src={searchIcon} width="15" />
          </button>
        </div>
        <input type="hidden" name="scope" value={scope} />
      </form>
    </div>
  );
}
